import React, { FC, useMemo } from "react";
import Image from "components/Elements/Image/Image.tsx";
import Icon from "components/Elements/Icon/Icon.tsx";
import GetTransformedDate from "utils/dateViewTransformer";
import { useMail } from "contexts/mailContext/mailContext";
import { useContent } from "contexts/contentContext/contentContext";
import { homeColors } from "helpers/getBackgroundColor";

import "./contributorsSideBar.scss";

interface IContributorComponent {
  data: {
    fullName: string;
    lastDate: string;
    quantityOfFiles: number;
    image?: string;
  };
  email: string;
}

const ContributorComponent: FC<IContributorComponent> = ({ data, email }) => {
  const { getTextByKey } = useContent();
  const { getContributorsFilter, setContributorsFilter, getFilesLoading } =
    useMail();

  const selected = getContributorsFilter().includes(email);

  const handleClick = () => {
    setContributorsFilter(email);
  };

  const randColor = useMemo(() => {
    return homeColors[Math.floor(Math.random() * homeColors.length)];
  }, []);

  const styleObj = useMemo(() => {
    return !data.image
      ? {
          backgroundColor: randColor,
        }
      : {};
  }, [data.image, randColor]);

  return (
    <li
      className={`contributors-list-item${
        getFilesLoading() ? " disabled" : ""
      }`}
      onClick={handleClick}
    >
      <Icon
        name={`checkbox${selected ? "_marked" : ""}`}
        iconClass={`checkbox${selected ? " selected" : ""}`}
        blue
      />
      <div className="avatar-container" style={styleObj}>
        {data.image ? <Image src={data.image} /> : email.charAt(0)}
      </div>
      <div className="contributor-info">
        {data.fullName && (
          <div className="contributor-name">{data.fullName}</div>
        )}
        <div className="contributor-email">{email}</div>
      </div>
      <div className="flex-spacer" />
      <div className="contributor-upload-data">
        <div className="upload-date">
          <GetTransformedDate date={data.lastDate} />
        </div>
        <div className="upload-quantity">
          {data.quantityOfFiles + " " + getTextByKey("files")}
        </div>
      </div>
    </li>
  );
};

const ContributorsSideBar = () => {
  const {} = useContent();
  const {} = useMail();

  return <></>;
};

export default ContributorsSideBar;
